function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = { detail: data };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

window.recentlyViewedIds = [];

/**
 * Quantity Selector
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      if (!this.input) return;

      this.step = Number(this.input.getAttribute('step')) || 1;
      this.changeEvent = new Event('change', { bubbles: true });

      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      this.subtract?.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add?.addEventListener('click', () => this.change_quantity(1 * this.step));
    }

    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }

    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      const min = Number(this.input.getAttribute('min')) || 1;
      const max = this.input.getAttribute('max') ? Number(this.input.getAttribute('max')) : null;

      if (quantity + change < min) return;
      if (max !== null && quantity + change > max) return;

      quantity += change;
      quantity = Math.max(quantity, min);

      this.input.value = quantity;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }

    validateQtyRules() {
      const value = parseInt(this.input.value || '1', 10);

      if (this.input.min && this.subtract) {
        const min = parseInt(this.input.min, 10);
        this.subtract.classList.toggle('disabled', value <= min);
      }

      if (this.input.max && this.add) {
        const max = parseInt(this.input.max, 10);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }

  customElements.define('quantity-selector', QuantityInput);
}

/**
 * Arrow Sub Menu
 */
class ArrowSubMenu {
  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    if (!this.submenu) return;

    if (!this.submenu.classList.contains('active')) {
      this.submenu.classList.add('active');
    } else {
      this.submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}

document.querySelectorAll('.thb-arrow').forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 * Product Card
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }

    connectedCallback() {
      if (this.swatches) this.enableSwatches(this.swatches, this.image);
      if (this.additional_images?.length) this.enableAdditionalImages();
      if (this.quick_add) this.enableQuickAdd();
      if (this.size_options) this.enableSizeOptions();
    }

    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');

      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];

        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) nav[index].classList.remove('active');
          }
        });

        if (selimg && !selimg.classList.contains('hover')) {
          selimg.classList.add('hover');
          if (nav.length) nav[sel]?.classList.add('active');
        }
      };

      const mouseleave = function () {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) nav[index].classList.remove('active');
        });
      };

      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, { passive: true });
        image_container.addEventListener('touchmove', mousemove, { passive: true });
        image_container.addEventListener('touchend', mouseleave, { passive: true });
        image_container.addEventListener('mouseenter', mousemove, { passive: true });
        image_container.addEventListener('mousemove', mousemove, { passive: true });
        image_container.addEventListener('mouseleave', mouseleave, { passive: true });
      }

      images.forEach(function (image) {
        window.addEventListener('load', () => {
          if (window.lazySizes?.loader) lazySizes.loader.unveil(image);
        });
      });
    }

    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch');
      let org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch) => {
        window.addEventListener('load', () => {
          let preloadImage = new Image();
          preloadImage.srcset = swatch.dataset.srcset;
          if (window.lazySizes?.loader) lazySizes.loader.unveil(preloadImage);
        });

        swatch.addEventListener('mouseover', () => {
          swatch_list.forEach((el) => el.classList.remove('active'));

          if (image) {
            image.setAttribute('srcset', swatch.dataset.srcset || org_srcset);
          }

          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span')?.innerText || '';
            this.updateMasterId();
          }

          swatch.classList.add('active');
        });

        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }

    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size');
      let featured_image = this.querySelector('.product-card--featured-image');
      let has_hover = featured_image?.classList.contains('thb-hover');
      let size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;
      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent?.addEventListener('mouseenter', () => {
        if (has_hover && featured_image) featured_image.classList.remove('thb-hover');
      }, { passive: true });

      size_parent?.addEventListener('mouseleave', () => {
        if (has_hover && featured_image) featured_image.classList.add('thb-hover');
      }, { passive: true });

      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();
          if (size.classList.contains('is-disabled')) return;

          this.current_options[this.size_index] = size.querySelector('span')?.innerText || '';
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);

          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };

          let formData = new FormData();
          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) return;

              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });

      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    setDisabled() {
      const variant_data = this.getVariantData();
      if (!variant_data) return true;

      if (this.currentVariant) {
        const selected_options = this.currentVariant.options.map((value, index) => ({
          value,
          index: `option${index + 1}`
        }));

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
        const fieldset_options = Object.values(available_options)[this.size_index];

        if (fieldset_options && this.size_options.querySelectorAll('.product-card-sizes--size').length) {
          this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
            input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
          });
        }
      } else {
        if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
          this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input) => {
            input.classList.add('is-disabled');
          });
        }
      }

      return true;
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, { value, index }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) return;

      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();
      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) return;

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart',
          section: 'main-cart',
          selector: '.thb-cart-form'
        },
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (!document.getElementById(section.id)) return;

        const host = document.getElementById(section.id);
        const elementToReplace = host.querySelector(section.selector) || host;

        if (parsedState.sections?.[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }
      });

      const cartDrawerEl = document.getElementById('Cart-Drawer');

      if (cartDrawerEl) {
        if (typeof cartDrawerEl.notesToggle === 'function') cartDrawerEl.notesToggle();
        if (typeof cartDrawerEl.removeProductEvent === 'function') cartDrawerEl.removeProductEvent();
        if (typeof cartDrawerEl.updateFreeShipping === 'function') cartDrawerEl.updateFreeShipping();
        if (typeof cartDrawerEl.termsCheckbox === 'function') cartDrawerEl.termsCheckbox();

        const cartToggle = document.getElementById('cart-drawer-toggle');
        if (cartToggle && !cartToggle.hasAttribute('data-cart-toggle-bound')) {
          cartToggle.setAttribute('data-cart-toggle-bound', 'true');
          cartToggle.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('open-cc');
            document.body.classList.add('open-cart');
            cartDrawerEl.classList.add('active');
            cartDrawerEl.focus();
            setTimeout(() => {
              cartDrawerEl.querySelector('.product-recommendations--full')?.classList.add('active');
            });
            dispatchCustomEvent('cart-drawer:open');
          });
        }

        cartDrawerEl.classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');

        if (cartDrawerEl.querySelector('.product-recommendations--full')) {
          cartDrawerEl.querySelector('.product-recommendations--full').classList.add('active');
        }

        dispatchCustomEvent('cart-drawer:open');
      }

      if (document.getElementById('Cart') && typeof Cart !== 'undefined') {
        new Cart().renderContents(parsedState);
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = doc.querySelector(selector);
      return target ? target.innerHTML : html;
    }
  }

  customElements.define('product-card', ProductCard);
}

/**
 * Header
 */
class Header {
  constructor() {
    const header = document.querySelector('.header-section');
    const header_main = document.getElementById('header');
    const menu = document.getElementById('mobile-menu');
    const toggle = document.querySelector('.mobile-toggle-wrapper');

    if (!header_main || !toggle || !menu) return;

    document.addEventListener('keyup', (e) => {
      if (e.code && e.code.toUpperCase() === 'ESCAPE') {
        toggle.removeAttribute('open');
        toggle.classList.remove('active');
      }
    });

    const mobileToggleButton = toggle.querySelector('.mobile-toggle');
    mobileToggleButton?.addEventListener('click', (e) => {
      this.setAnnouncementHeight(header);

      if (toggle.classList.contains('active')) {
        e.preventDefault();
        document.body.classList.remove('overflow-hidden');
        toggle.classList.remove('active');
        this.closeAnimation(toggle);
      } else {
        document.body.classList.add('overflow-hidden');
        setTimeout(() => {
          toggle.classList.add('active');
        });
      }

      window.dispatchEvent(new Event('resize.resize-select'));
    });

    window.addEventListener('scroll', () => {
      this.setHeaderOffset(header);
      this.setHeaderHeight(header_main);

      if (header_main.classList.contains('header-sticky--active')) {
        let offset = parseInt(header_main.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        header_main.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }, { passive: true });

    window.dispatchEvent(new Event('scroll'));

    if (document.getElementById('shopify-section-announcement-bar')) {
      const a_bar = document.getElementById('shopify-section-announcement-bar');
      window.addEventListener('resize', () => {
        this.setAnnouncementHeight(a_bar);
      }, { passive: true });
      window.dispatchEvent(new Event('resize'));
    }

    menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    menu.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  setAnnouncementHeight(a_bar) {
    if (!a_bar) return;
    let h = a_bar.clientHeight;
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
  }

  setHeaderOffset(header) {
    if (!header) return;
    let h = header.getBoundingClientRect().top;
    document.documentElement.style.setProperty('--header-offset', h + 'px');
  }

  setHeaderHeight(header) {
    if (!header) return;
    let h = header.clientHeight;
    document.documentElement.style.setProperty('--header-height', h + 'px');
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.link-container');

    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      parentMenuElement && parentMenuElement.classList.add('submenu-open');
    }, 100);
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        detailsElement.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
          details.classList.remove('submenu-open');
        });
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

/**
 * Localization
 */
class Localization {
  constructor() {
    document.querySelectorAll('.thb-localization-forms').forEach((localization) => {
      localization.addEventListener('change', () => {
        localization.querySelector('form')?.submit();
      });
    });
  }
}

/**
 * Panel Close
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) this.close_panel(e, panel[0]);
      };

      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));

      if (this.cc && !this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }
    }

    close_panel(e, panel) {
      if (e) e.preventDefault();

      if (!panel) {
        panel = e?.target.closest('.side-panel.active');
        if (!panel) return;
      }

      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }

        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }

    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');
      if (!panel) return;

      panel.querySelector('.product-quick-images--container')?.classList.remove('active');

      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            const content = panel.querySelector('#Product-Drawer-Content');
            if (content) content.innerHTML = '';
          }, 500);
        }
      }
    }
  }

  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code && e.code.toUpperCase() === 'ESCAPE') {
      dispatchCustomEvent('panel:close');
    }
  });
}

/**
 * Cart Drawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this._boundToggleHandler = null;
    }

    connectedCallback() {
      this.initDrawer();
    }

    initDrawer() {
      this.bindToggleButton();

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.removeEventListener('change', this.debouncedOnChange);
      this.addEventListener('change', this.debouncedOnChange.bind(this));

      document.addEventListener('cart:refresh', () => {
        this.refresh();
      });

      this.notesToggle();
      this.removeProductEvent();
      this.updateFreeShipping();
      this.termsCheckbox();
    }

    bindToggleButton() {
      const button = document.getElementById('cart-drawer-toggle');
      if (!button) return;

      if (button.hasAttribute('data-cart-toggle-bound')) return;

      button.setAttribute('data-cart-toggle-bound', 'true');
      button.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();

        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });

        dispatchCustomEvent('cart-drawer:open');
      });
    }

    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }

    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        if (remove.hasAttribute('data-remove-bound')) return;

        remove.setAttribute('data-remove-bound', 'true');
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          const index = remove.dataset.index || event.target.dataset.index;
          this.updateQuantity(index, '0');
        });
      });
    }

    getSectionsToRender() {
      return [
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }
      ];
    }

    getSectionInnerHTML(html, selector) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const target = doc.querySelector(selector);
      return target ? target.innerHTML : html;
    }

    termsCheckbox() {
      let terms_checkbox = this.querySelector('#CartDrawerTerms');
      let checkout_button = this.querySelector('.button.checkout, .button.checkout-button');

      if (terms_checkbox && checkout_button) {
        if (theme?.strings?.requiresTerms) {
          terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
        }

        if (!checkout_button.hasAttribute('data-terms-bound')) {
          checkout_button.setAttribute('data-terms-bound', 'true');
          checkout_button.addEventListener('click', function (e) {
            if (!terms_checkbox.checked) {
              terms_checkbox.reportValidity();
              terms_checkbox.focus();
              e.preventDefault();
            }
          });
        }
      }
    }

    notesToggle() {
      const notes_toggle = this.querySelector('#order-note-toggle') || document.getElementById('order-note-toggle');
      if (!notes_toggle) return;

      if (!notes_toggle.hasAttribute('data-notes-bound')) {
        notes_toggle.setAttribute('data-notes-bound', 'true');

        notes_toggle.addEventListener('click', () => {
          notes_toggle.nextElementSibling?.classList.add('active');
        });
      }

      const panel = notes_toggle.nextElementSibling;
      if (!panel) return;

      panel.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        if (el.hasAttribute('data-note-close-bound')) return;

        el.setAttribute('data-note-close-bound', 'true');
        el.addEventListener('click', () => {
          panel.classList.remove('active');
          this.saveNotes();
        });
      });
    }

    saveNotes() {
      const noteField = this.querySelector('#mini-cart__notes') || document.getElementById('mini-cart__notes');
      if (!noteField) return;

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          note: noteField.value
        })
      });
    }

    updateFreeShipping() {
      const free_shipping = this.querySelector('.free-shipping');
      if (!free_shipping) return;

      // free-shipping.js owns this logic - it is the only place that resolves the
      // buyer country, and therefore which of the two thresholds applies. A copy of
      // the maths used to live here keyed off Shopify.currency.active alone, which
      // reset international carts back to the US amount on every cart update.
      if (typeof free_shipping.update === 'function') free_shipping.update();
    }

    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');

      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', { quantity });

      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body
      })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const host = document.getElementById(section.id);
            if (!host) return;

            const elementToReplace = host.querySelector(section.selector) || host;

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          });

          const refreshedDrawer = document.getElementById('Cart-Drawer');
          if (refreshedDrawer) {
            if (typeof refreshedDrawer.notesToggle === 'function') refreshedDrawer.notesToggle();
            if (typeof refreshedDrawer.removeProductEvent === 'function') refreshedDrawer.removeProductEvent();
            if (typeof refreshedDrawer.updateFreeShipping === 'function') refreshedDrawer.updateFreeShipping();
            if (typeof refreshedDrawer.termsCheckbox === 'function') refreshedDrawer.termsCheckbox();
            if (typeof refreshedDrawer.bindToggleButton === 'function') refreshedDrawer.bindToggleButton();
          }

          dispatchCustomEvent('line-item:change:end', {
            quantity,
            cart: parsedState
          });

          document.getElementById('Cart-Drawer')?.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        })
        .catch((error) => {
          console.error(error);
          document.getElementById('Cart-Drawer')?.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }

    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      let sections = 'cart-drawer,cart-bubble';

      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section) => {
            const host = document.getElementById(section.id);
            if (!host) return;

            const elementToReplace = host.querySelector(section.selector) || host;
            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          });

          const refreshedDrawer = document.getElementById('Cart-Drawer');
          if (refreshedDrawer) {
            if (typeof refreshedDrawer.notesToggle === 'function') refreshedDrawer.notesToggle();
            if (typeof refreshedDrawer.removeProductEvent === 'function') refreshedDrawer.removeProductEvent();
            if (typeof refreshedDrawer.updateFreeShipping === 'function') refreshedDrawer.updateFreeShipping();
            if (typeof refreshedDrawer.termsCheckbox === 'function') refreshedDrawer.termsCheckbox();
            if (typeof refreshedDrawer.bindToggleButton === 'function') refreshedDrawer.bindToggleButton();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

/**
 * Select Width
 */
class SelectWidth {
  constructor() {
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect);
    });

    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        this.resizeSelect(e.target);
      }
    });

    window.addEventListener('resize.resize-select', () => {
      document.querySelectorAll('.resize-select').forEach(this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    let offset = 13;

    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);

    if (
      sel.classList.contains('thb-language-code') ||
      sel.classList.contains('thb-currency-code') ||
      sel.classList.contains('facet-filters__sort')
    ) {
      offset = 2;
    }

    sel.after(tempSelect);

    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }

    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 * Footer Menu Toggle
 */
class FooterMenuToggle {
  constructor() {
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', () => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 * Quick View
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;
      this.addEventListener('click', this.setupEventListener.bind(this));
    }

    setupEventListener(e) {
      e.preventDefault();

      let productHandle = this.dataset.productHandle;
      let href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      href = href.replace('//', '/');

      if (!href || !productHandle) return;
      if (this.classList.contains('loading')) return;

      this.classList.add('loading');

      fetch(href, { method: 'GET' })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then((text) => {
          const parsed = new DOMParser().parseFromString(text, 'text/html');
          const sectionTarget = parsed.querySelector('#Product-Drawer-Content');
          if (!sectionTarget) return;

          this.renderQuickview(sectionTarget.innerHTML, href, productHandle);
        });
    }
renderQuickview(sectionInnerHTML, href, productHandle) {
  if (!sectionInnerHTML || !this.drawer) {
    return;
  }

  this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

  let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

  if (js_files.length > 0) {
    var head = document.getElementsByTagName('head')[0];

    js_files.forEach((js_file) => {
      if (!js_file.src) return;

      let script = document.createElement('script');
      script.src = js_file.src;
      head.appendChild(script);
    });
  }

  setTimeout(() => {
    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
    if (window.ProductModel) {
      window.ProductModel.loadShopifyXR();
    }
  }, 300);

  this.body.classList.add('open-cc');
  this.body.classList.add('open-quick-view');
  this.drawer.classList.add('active');

  this.drawer.querySelector('.side-panel-close')?.focus();

  setTimeout(() => {
    this.drawer.querySelector('.product-quick-images--container')?.classList.add('active');
  });

  dispatchCustomEvent('quick-view:open', {
    productUrl: href,
    productHandle: productHandle
  });

  if (window.jQuery && jQuery('#dpo_scripts')[0]) {
    try {
      eval(jQuery('#dpo_scripts').html());
    } catch (e) {
      console.log(e);
    }
  }

  if (window.buildBundleListV2) {
    window.buildBundleListV2();
  }

  addIdToRecentlyViewed(productHandle);
}
}

customElements.define('quick-view', QuickView);
}
/**
 * Side Panel Content Tabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }

    connectedCallback() {
      this.setupButtonObservers();
    }

    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.toggleActiveClass(i);
        });
      });
    }

    toggleActiveClass(i) {
      this.buttons.forEach((button) => button.classList.remove('tab-active'));
      this.buttons[i]?.classList.add('tab-active');

      this.panels.forEach((panel) => panel.classList.remove('tab-active'));
      this.panels[i]?.classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 * Collapsible Row
 */
if (!customElements.get('collapsible-row')) {
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
    }

    connectedCallback() {
      this.setListeners();
    }

    setListeners() {
      this.querySelector('summary')?.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = 'hidden';

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) this.animation.cancel();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 250, easing: 'ease' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) this.animation.cancel();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration: 400, easing: 'ease-out' }
      );

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  }

  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 * Recently Viewed
 */
function addIdToRecentlyViewed(handle) {
  if (!handle) {
    let product = document.querySelector('.thb-product-detail');
    if (product) handle = product.dataset.handle;
  }

  if (!handle) return;

  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds && recentIds !== 'undefined') {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }

  let i = window.recentlyViewedIds.indexOf(handle);
  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

/**
 * DOM Ready Init
 */
document.addEventListener('DOMContentLoaded', () => {
  if (typeof Localization !== 'undefined') {
    new Localization();
  }

  if (typeof Header !== 'undefined') {
    new Header();
  }

  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }

  const cartDrawerEl = document.getElementById('Cart-Drawer');
  const cartToggle = document.getElementById('cart-drawer-toggle');

  if (cartDrawerEl) {
    if (typeof cartDrawerEl.bindToggleButton === 'function') cartDrawerEl.bindToggleButton();
    if (typeof cartDrawerEl.notesToggle === 'function') cartDrawerEl.notesToggle();
    if (typeof cartDrawerEl.removeProductEvent === 'function') cartDrawerEl.removeProductEvent();
    if (typeof cartDrawerEl.updateFreeShipping === 'function') cartDrawerEl.updateFreeShipping();
    if (typeof cartDrawerEl.termsCheckbox === 'function') cartDrawerEl.termsCheckbox();
  }

  if (cartDrawerEl && cartToggle && !cartToggle.hasAttribute('data-cart-toggle-bound')) {
    cartToggle.setAttribute('data-cart-toggle-bound', 'true');
    cartToggle.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      cartDrawerEl.classList.add('active');
      cartDrawerEl.focus();

      setTimeout(() => {
        cartDrawerEl.querySelector('.product-recommendations--full')?.classList.add('active');
      });

      dispatchCustomEvent('cart-drawer:open');
    });
  }
});


